import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import i18n from "../i18n";
import { apiFetcher } from "../services/API.service";
import {
  isBidderFavoriteProducts,
  isHistoryItem,
  isRespViewProfile,
  isRewardHistory,
  isShippingData,
  isShippingProfileData,
  isShortProduct,
  isWinningsAuctionItem,
  isWinningsFilterOptions
} from "../utilities/dataValidators";
import { decodeUserJWT } from "../utilities/utils";
import { getSignedUrls, sendToS3 } from "./images.model";

// export type ShippingProfileData = {
//   id: number;
//   title: string;
//   recipient_name: string;
//   recipient_mobile: string;
//   street_address: string;
//   complex?: string;
//   suburb: string;
//   city: string;
//   province: string;
//   postal_code: string;
// };

//For transactions start
// Move in future if needed
export async function postSuccessfulPayment(transactionID: string): Promise<
  | {
      rStatus: "success";
      rData: string;
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    const response = await apiFetcher({
      route: "/payment/success",
      method: "POST",
      options: {
        body: {
          refreshToken: refreshToken,
          transactionID: transactionID,
          transactionStatus: "successful",
          transactionGateWay: "yoco"
        }
      }
    });
    if (response.status === 202) {
      return {
        rStatus: "success",
        rData: ""
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

// Move in future if needed
export async function postNewTransaction(
  transactionID: string,
  amount: number
): Promise<
  | {
      rStatus: "success";
      rData: string;
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    const response = await apiFetcher({
      route: "/payment/add",
      method: "POST",
      options: {
        body: {
          refreshToken: refreshToken,
          transactionID: transactionID,
          transactionStatus: "successful",
          transactionGateWay: "yoco",
          transactionCurrencyCode: "ZAR",
          transactionAmount: amount
        }
      }
    });
    if (response.status === 202) {
      return {
        rStatus: "success",
        rData: ""
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}
//For transactions end

export async function fetchUserProfileData(): Promise<
  | {
      rStatus: "success";
      rData: RespViewProfile;
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const response = await apiFetcher({
      route: "/profile/view",
      method: "POST",
      options: {
        body: {}
      }
    });

    if (response.status === 200) {
      if (!response.data || typeof response.data !== "object") {
        console.log("Response data is not an object");
        return {
          rStatus: "error",
          message: "Data is not an object"
        };
      }

      if (!isRespViewProfile(response.data)) {
        console.log("Response data is not of type RespViewProfile");
        return {
          rStatus: "error",
          message: "Data is not of type RespViewProfile"
        };
      }

      return {
        rStatus: "success",
        rData: response.data
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

export async function sendReport({
  fullName,
  email,
  cellNumber,
  message,
  type
}: {
  fullName: string;
  email: string;
  cellNumber: string;
  message: string;
  type: string;
}): Promise<
  | {
      rStatus: "success";
      rData: string;
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    const response = await apiFetcher({
      route: "/report/create",
      method: "POST",
      options: {
        body: {
          fullName: fullName,
          email: email,
          cellNumber: cellNumber,
          message: message,
          type: type
        }
      },
      excludeToken: refreshToken ? false : true
    });

    if (response.status === 202) {
      return {
        rStatus: "success",
        rData: "Report submitted successfully."
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

export async function sendWinningsImage({
  itemId,
  selectedFile
}: {
  itemId: number;
  selectedFile: {
    full: string;
    thumb: string;
  };
}): Promise<
  | {
      rStatus: "success";
      rData: string | null;
    }
  | { rStatus: "error"; message: string }
> {
  try {
    let imageKeys = undefined;
    // get file type from base64, minus "data:image/"
    const fileTypeF = selectedFile.full
      .split(";")[0]
      .split(":")[1]
      .split("/")[1];

    console.log(fileTypeF);

    if (!fileTypeF && fileTypeF !== "") {
      console.log("File type could not be determined");
      return { rStatus: "error", message: "File type could not be determined" };
    }

    const fileTypeT = selectedFile.thumb
      .split(";")[0]
      .split(":")[1]
      .split("/")[1];

    console.log(fileTypeT);

    const signedURLResponse = await getSignedUrls(
      "winner",
      fileTypeF,
      fileTypeT
    );

    console.log("Response image upload", signedURLResponse);

    // if signedURLResponse is false, return error
    if (!signedURLResponse) {
      return { rStatus: "error", message: "Failed to get signed URL" };
    }

    const sentToS3 = await sendToS3(
      {
        full: selectedFile.full,
        thumb: selectedFile.thumb
      },
      fileTypeF,
      fileTypeF,
      signedURLResponse
    );

    if (!sentToS3) {
      return { rStatus: "error", message: "Failed to upload image to S3" };
    } else {
      console.log("Image uploaded to S3");
      imageKeys = {
        full: signedURLResponse.keyF,
        thumb:
          (signedURLResponse.type === "both" && signedURLResponse.keyT) ||
          undefined
      };
    }

    // Send the uploaded image information to the backend
    // const formData: { [key: string]: unknown } = {};
    // formData["fullOrThumb"] = { thumb: signedURLResponse.keyF };
    // formData["category"] = "winner";
    // console.log(formData);

    const newFormData = {
      auctionID: itemId,
      fullOrThumb: imageKeys,
      category: "winner"
    };

    console.log(newFormData);

    const response = await apiFetcher({
      route: "/image/save",
      method: "POST",
      options: {
        body: newFormData
      }
    });

    console.log(response);

    // if (response.status === 200) {
    //   if (
    //     !response.data ||
    //     typeof response.data !== "object" ||
    //     !("uploadedPhoto" in response.data) ||
    //     typeof response.data.uploadedPhoto !== "string"
    //   ) {
    //     return {
    //       rStatus: "success",
    //       rData: null
    //     };
    //   }
    //   return {
    //     rStatus: "success",
    //     rData: response.data.uploadedPhoto
    //   };
    // }

    if (response.status === 200) {
      try {
        // gets an array of objects. Look for object with key "uploadedPhoto"
        // if it exists, return the value of that key

        if (
          !response.data ||
          !Array.isArray(response.data) ||
          response.data.length === 0
        ) {
          return {
            rStatus: "success",
            rData: null
          };
        }

        const uploadedPhoto: { uploadedPhoto: unknown } = response.data.find(
          (item) => "uploadedPhoto" in item
        );

        if (!uploadedPhoto || typeof uploadedPhoto.uploadedPhoto !== "string") {
          return {
            rStatus: "success",
            rData: null
          };
        }

        return {
          rStatus: "success",
          rData: uploadedPhoto.uploadedPhoto
        };
      } catch (error) {
        return {
          rStatus: "success",
          rData: null
        };
      }
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

export async function removeWinningsImage(itemId: number): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const response = await apiFetcher({
      route: "/winnings/removeImage",
      method: "POST",
      options: {
        body: {
          auctionID: itemId,
          category: "winner"
        }
      }
    });

    if (response.status === 202) {
      return {
        rStatus: "success"
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

export async function sendEditedUserProfileData({
  fields
}: {
  fields: {
    firstName: string;
    lastName: string;
    email: string;
    nickName: string;
    profileImage: string;
    newProfileImage: boolean;
    mobileNumber: string;
    location: string;
    language: string;
  };
}): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; message: string }
> {
  console.log("Fields", fields);
  let imageKeys = undefined;
  if (fields.newProfileImage) {
    // get file type from base64, minus "data:image/"
    const fileTypeF = fields.profileImage
      .split(";")[0]
      .split(":")[1]
      .split("/")[1];

    console.log(fileTypeF);

    if (!fileTypeF && fileTypeF !== "") {
      console.log("File type could not be determined");
      return { rStatus: "error", message: "File type could not be determined" };
    }
    const signedURLResponse = await getSignedUrls(
      "profile",
      fileTypeF,
      fileTypeF
    );

    console.log("Response image upload", signedURLResponse);

    // if signedURLResponse is false, return error
    if (!signedURLResponse) {
      return { rStatus: "error", message: "Failed to get signed URL" };
    }

    const sentToS3 = await sendToS3(
      {
        full: fields.profileImage
      },
      fileTypeF,
      fileTypeF,
      signedURLResponse
    );

    if (!sentToS3) {
      return { rStatus: "error", message: "Failed to upload image to S3" };
    } else {
      console.log("Image uploaded to S3");
      imageKeys = {
        full: signedURLResponse.keyF,
        thumb:
          (signedURLResponse.type === "both" && signedURLResponse.keyT) ||
          undefined
      };
    }
  }

  const profileImageLink =
    !fields.newProfileImage || !imageKeys
      ? fields.profileImage
      : imageKeys.full;

  // send request to database server
  const response = await apiFetcher({
    route: "/profile/update",
    method: "POST",
    options: {
      body: {
        firstName: fields.firstName,
        lastName: fields.lastName,
        email: fields.email,
        nickName: fields.nickName,
        profileImage: profileImageLink,
        mobileNumber: fields.mobileNumber,
        location: fields.location,
        language: fields.language
      }
    }
  });

  // expect new token for successful response

  if (response.status === 200) {
    console.log("Response data", response.data);
    if (
      response.data &&
      typeof response.data === "object" &&
      "refreshToken" in response.data &&
      typeof response.data.refreshToken === "string"
    ) {
      const refreshToken = response.data.refreshToken;
      const tokenData = decodeUserJWT(refreshToken);
      if (!tokenData) {
        return { rStatus: "error", message: "JWT could not be decoded" };
      }
      console.log("refreshToken", refreshToken);
      localStorage.setItem("refreshToken", refreshToken);
      return { rStatus: "success" };
    }
    console.log("Data is not in expected format");
    return { rStatus: "error", message: "An error occurred" };
  }

  if (response.status === 209) {
    return { rStatus: "error", message: i18n.t("Username already exists") };
  }

  return { rStatus: "error", message: "An error occurred" };
}

export async function fetchUserProfileIcon(): Promise<
  | {
      rStatus: "success";
      rData: {
        profileImage: string;
        expires: string;
      };
    }
  | { rStatus: "error"; message: string }
> {
  try {
    // Ensure the refresh token is included in the body
    const response = await apiFetcher({
      route: "/profile/icon",
      method: "POST", // Use POST if your backend expects it
      options: {
        body: {
          // refreshToken: localStorage.getItem("refreshToken")
        }
      }
    });

    // Check the response status and handle accordingly
    if (response.status === 200) {
      if (!response.data || typeof response.data !== "object") {
        console.log("Response data is not an object");
        return {
          rStatus: "error",
          message: "Data is not an object"
        };
      }
      // console.log(response.data, "response.data");
      if (
        !("profileImage" in response.data) ||
        typeof response.data.profileImage !== "string"
      ) {
        console.log("profileImage is not a string");
        return {
          rStatus: "error",
          message: "profileImage is not a string"
        };
      }

      // if (response.data.profileImage === "") {
      //   return {
      //     rStatus: "error",
      //     message: "profileImage is empty"
      //   };
      // }

      if (
        !("expires" in response.data) ||
        !response.data.expires ||
        typeof response.data.expires !== "string"
      ) {
        console.log("expires is not a string");
        return {
          rStatus: "error",
          message: "expires is not a string"
        };
      }
      return {
        rStatus: "success",
        rData: response.data as {
          profileImage: string;
          expires: string;
        }
      };
    } else {
      console.log("An error occurred with status:", response.status);
      return {
        rStatus: "error",
        message: `Error occurred with status code ${response.status}`
      };
    }
  } catch (error) {
    console.log("An error occurred while fetching the profile image:", error);
    return { rStatus: "error", message: "An error occurred" };
  }
}

export async function fetchUserShippingData(): Promise<
  | {
      rStatus: "success";
      rData: ShippingData;
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const response = await apiFetcher({
      route: "/shipping/get",
      method: "POST",
      options: {
        body: {}
      }
    });

    if (response.status === 200) {
      if (!response.data || typeof response.data !== "object") {
        console.log("Response data is not an object");
        return {
          rStatus: "error",
          message: "Data is not an object"
        };
      }

      if (!isShippingData(response.data)) {
        console.log("Response data is not of type ShippingData");
        console.log("Response data", response.data);
        return {
          rStatus: "error",
          message: "Data is not of type ShippingData"
        };
      }

      return {
        rStatus: "success",
        rData: response.data
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

export async function fetchUserShippingProfilesData(): Promise<
  | {
      rStatus: "success";
      rData: ShippingProfileData[];
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const response = await apiFetcher({
      route: "/shipping/get",
      method: "POST",
      options: {
        body: {}
      }
    });

    console.log("Response", response);

    // TODO: remember
    // type ShippingProfileData = ShippingProfileData & {
    //   id: number;
    //   profileName: string;
    // };

    if (response.status === 200) {
      if (!response.data || !Array.isArray(response.data)) {
        console.log("Response data is not an array");
        return {
          rStatus: "error",
          message: "Data is not an array"
        };
      }

      if (
        response.data.some(
          (item) => !isShippingProfileData(item) || typeof item.id !== "number"
        )
      ) {
        console.log("Response data is not of type ShippingProfileData");
        return {
          rStatus: "error",
          message: "Data is not of type ShippingProfileData"
        };
      }

      return {
        rStatus: "success",
        rData: response.data
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

export async function sendUserShippingProfileData(
  profile: ShippingProfileData,
  newProfile: boolean
) {
  try {
    Swal.fire({
      title: i18n.t("Saving"),
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
      customClass: {
        popup: "!rounded-lg swal-loading-custom"
      }
    });

    const apiRoute = newProfile ? "/shipping/create" : "/shipping/update";

    const body: {
      id?: number;
      title: string;
      recipientName: string;
      recipientMobile: string;
      streetAddress: string;
      complex: string;
      suburb: string;
      city: string;
      province: string;
      postalCode: string;
      country: string;
    } = {
      id: newProfile ? undefined : profile.id,
      title: profile.title,
      recipientName: profile.recipient_name,
      recipientMobile: profile.recipient_mobile,
      streetAddress: profile.street_address,
      complex: profile.complex ?? "",
      suburb: profile.suburb,
      city: profile.city,
      province: profile.province,
      postalCode: profile.postal_code,
      country: profile.country
    };

    if (!newProfile) {
      body.id = profile.id;
    }

    const response = await apiFetcher({
      route: apiRoute,
      method: "POST",
      options: {
        body: body
      }
    });

    Swal.close();

    if (response.status === 202) {
      return { rStatus: "success" };
    }

    return { rStatus: "error", message: "An error occurred" };
  } catch (error) {
    Swal.close();
    return { rStatus: "error", message: "An error occurred" };
  }
}

export async function deleteShippingProfileData(profileID: number) {
  try {
    Swal.fire({
      title: i18n.t("Deleting"),
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
      customClass: {
        popup: "!rounded-lg swal-loading-custom"
      }
    });

    const response = await apiFetcher({
      route: "/shipping/delete",
      method: "POST",
      options: {
        body: {
          shippingID: profileID
        }
      }
    });
    Swal.close();

    if (response.status === 202) {
      return { rStatus: "success" };
    }

    return { rStatus: "error", message: "An error occurred" };
  } catch (error) {
    Swal.close();
    return { rStatus: "error", message: "An error occurred" };
  }
}

export async function fetchUserWinningsData({
  filterStatus,
  filterCourier,
  filterTracking,
  filterDaysLeft,
  filterPaid,
  filterSort,
  pageNumber,
  pageSize,
  signal
}: {
  filterStatus: string[] | undefined;
  filterCourier: string[] | undefined;
  filterTracking: string[] | undefined;
  filterDaysLeft: number[] | undefined;
  filterPaid: string[] | undefined;
  filterSort: AllURLFilterValues["sort"];
  pageNumber: number | undefined;
  pageSize: number | undefined;
  signal?: AbortSignal;
}): Promise<
  | {
      rStatus: "success";
      rData: {
        products: WinningsAuctionItem[];
        filterOptions: WinningsFilterOptions;
        totalProducts: number;
      };
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const response = await apiFetcher({
      route: "/orders/history",
      method: "POST",
      options: {
        body: {
          status: filterStatus,
          courier: filterCourier,
          tracking: filterTracking,
          daysLeft: filterDaysLeft,
          paid: filterPaid,
          sort: filterSort,
          pageNumber: pageNumber,
          pageSize: pageSize
        }
      },
      signal: signal
    });

    if (response.status === 200) {
      let products: WinningsAuctionItem[] = [];
      let filterOptions: WinningsFilterOptions = {
        status: []
        // courier: [],
        // tracking: [],
        // daysLeft: [],
        // paid: []
      };
      let totalProducts: number = 0;

      if (!response.data || typeof response.data !== "object") {
        console.log("Response data is not an object");
        return {
          rStatus: "error",
          message: "Data is not an object"
        };
      }

      console.log(response.data);
      // console log all keys of data
      console.log(Object.keys(response.data));

      if (
        !("orders" in response.data) ||
        !Array.isArray(response.data.orders)
      ) {
        console.log("orders is not an array");
        return {
          rStatus: "error",
          message: "Products is not an array"
        };
      }

      if (response.data.orders.some((item) => !isWinningsAuctionItem(item))) {
        console.log("Products data is not of type WinningsAuctionItem");
        return {
          rStatus: "error",
          message: "Products is not of type WinningsAuctionItem"
        };
      }

      if (!("totalItems" in response.data)) {
        console.log("totalItems is not in response");
        return {
          rStatus: "error",
          message: "totalItems is not in response"
        };
      }

      if (typeof response.data.totalItems !== "number") {
        console.log("totalItems is not a number");
        return {
          rStatus: "error",
          message: "totalItems is not a number"
        };
      }

      if (!("filterOptions" in response.data)) {
        console.log("filterOptions is not in response");
        return {
          rStatus: "error",
          message: "filterOptions is not in response"
        };
      }

      if (!isWinningsFilterOptions(response.data.filterOptions)) {
        console.log("filterOptions is not of type WinningsFilterOptions");
        return {
          rStatus: "error",
          message: "filterOptions is not of type WinningsFilterOptions"
        };
      }

      products = response.data.orders;
      filterOptions = response.data.filterOptions;
      totalProducts = response.data.totalItems;

      return {
        rStatus: "success",
        rData: {
          products: products,
          filterOptions: filterOptions,
          totalProducts: totalProducts
        }
      };
    }

    if (response.status === 204) {
      return {
        rStatus: "success",
        rData: {
          products: [],
          filterOptions: {
            status: []
          },
          totalProducts: 0
        }
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

export async function fetchUserBidsHistoryData({
  minPrice,
  maxPrice,
  minDate,
  maxDate,
  auction,
  status,
  wonBy,
  sort,
  pageNumber,
  pageSize,
  signal
}: {
  minPrice?: number;
  maxPrice?: number;
  minDate?: number;
  maxDate?: number;
  auction?: number[];
  status?: string[];
  wonBy?: string[];
  sort: Readonly<AllURLFilterValues["sort"]>;
  pageNumber?: number;
  pageSize?: number;
  signal?: AbortSignal;
}): Promise<
  | {
      rStatus: "success";
      rData: {
        previousBids: HistoryItem[];
        totalProducts: number;
      };
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const response = await apiFetcher({
      route: "/bids/history",
      method: "POST",
      options: {
        body: {
          minPrice,
          maxPrice,
          minDate,
          maxDate,
          auction,
          status,
          wonBy,
          sort,
          pageNumber,
          pageSize
        }
      },
      signal: signal
    });

    console.log(signal);

    console.log(response);

    if (response.status === 200) {
      if (!response.data || typeof response.data !== "object") {
        console.log("Response data is not an object");
        return {
          rStatus: "error",
          message: i18n.t("An error occurred")
        };
      }

      console.log(response.data);

      if (
        !(
          "totalProducts" in response.data &&
          typeof response.data.totalProducts === "number"
        )
      ) {
        console.log("Response data is not an object");
        return {
          rStatus: "error",
          message: i18n.t("An error occurred")
        };
      }

      if (
        !(
          "previousBids" in response.data &&
          Array.isArray(response.data.previousBids)
        )
      ) {
        console.log("Response data is not an array");
        return {
          rStatus: "error",
          message: i18n.t("An error occurred")
        };
      }

      // TODO: handle case where previousBids is empty
      if (
        response.data.previousBids.length > 0 &&
        response.data.previousBids.some((item) => !isHistoryItem(item))
      ) {
        console.log(response.data.previousBids.length);
        console.log("Response data is not of type HistoryItem");
        return {
          rStatus: "error",
          message: i18n.t("An error occurred")
        };
      }

      return {
        rStatus: "success",
        rData: {
          totalProducts: response.data.totalProducts,
          previousBids: response.data.previousBids
        }
      };
    }

    if (response.status === 204) {
      return {
        rStatus: "success",
        rData: {
          totalProducts: 0,
          previousBids: []
        }
      };
    }

    return {
      rStatus: "error",
      message: i18n.t("An error occurred")
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: i18n.t("An error occurred")
    };
  }
}

export async function fetchUserOpenAuctionsData(): Promise<
  | {
      rStatus: "success";
      rData: ShortProduct[];
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const response = await apiFetcher({
      route: "/bids/active",
      method: "POST",
      options: {
        body: {}
      }
    });

    if (response.status === 200) {
      if (!response.data || !Array.isArray(response.data)) {
        console.log("Response data is not an array");
        return {
          rStatus: "error",
          message: "Data is not an array"
        };
      }

      if (response.data.some((item) => !isShortProduct(item))) {
        console.log("Response data is not of type WinningsAuctionItem");
        return {
          rStatus: "error",
          message: "Data is not of type WinningsAuctionItem"
        };
      }

      return {
        rStatus: "success",
        rData: response.data
      };
    }

    if (response.status === 204) {
      return {
        rStatus: "success",
        rData: []
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

export const useFetchOpenAuctions = () => {
  const [auctionItems, setAuctionItems] = useState<ShortProduct[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchUserOpenAuctionsData();
      if (response.rStatus === "success") {
        setAuctionItems(response.rData);
      } else {
        setError(response.message);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  return { auctionItems, loading, error };
};

export async function fetchUserFavoritesData(): Promise<
  | {
      rStatus: "success";
      rData: FavoriteProducts[];
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const response = await apiFetcher({
      route: "/favorite/get",
      method: "POST",
      options: {
        body: {}
      }
    });

    if (response.status === 200) {
      if (!response.data || !Array.isArray(response.data)) {
        console.log("Response data is not an array");
        return {
          rStatus: "error",
          message: "Data is not an array"
        };
      }

      if (response.data.some((item) => !isBidderFavoriteProducts(item))) {
        console.log("Response data is not of type WinningsAuctionItem");
        return {
          rStatus: "error",
          message: "Data is not of type WinningsAuctionItem"
        };
      }

      return {
        rStatus: "success",
        rData: response.data
      };
    }

    if (response.status === 204) {
      return {
        rStatus: "success",
        rData: []
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

export async function fetchRewardHistory(): Promise<
  | {
      rStatus: "success";
      rData: RewardHistory;
    }
  | { rStatus: "error"; message: string }
> {
  console.log("HIT THE FETCH REWARDS");
  try {
    const response = await apiFetcher({
      route: "/reward/history",
      method: "POST",
      options: {
        body: {
          // refreshToken: localStorage.getItem("refreshToken")
        }
      }
    });

    if (response.status === 200) {
      console.log("DATA: ", response.data);
      if (
        !response.data ||
        (typeof response.data !== "object" && !isRewardHistory(response.data))
      ) {
        console.log("Response data is not an object");
        return {
          rStatus: "error",
          message: "Data is not an object"
        };
      }
      return {
        rStatus: "success",
        rData: response.data as RewardHistory
      };
    }

    if (response.error && response.error === "network_error") {
      return {
        rStatus: "error",
        message: "Please check your internet connection and refresh the page."
      };
    }

    // Default Response
    return {
      rStatus: "error",
      message: "Couldn't fetch user reward history. Please try again later."
    };
  } catch (error: unknown) {
    if (error instanceof TypeError && error.message === "Failed to fetch") {
      return {
        rStatus: "error",
        message: "Please check your internet connection and refresh the page. "
      };
    }

    // Handle generic errors
    return {
      rStatus: "error",
      message: "Failed to fetch rewards data."
    };
  }
}

export async function checkIn(): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const response = await apiFetcher({
      route: "/reward/checkIn",
      method: "POST",
      options: {
        body: {}
      }
    });

    if (response.status === 200) {
      return {
        rStatus: "success"
      };
    }

    if (response.status === 209) {
      return {
        rStatus: "success"
      };
    }

    return {
      rStatus: "error",
      message: "An error occurred"
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}

export async function requestProcessPayment({
  cartTotal,
  paymentMethod,
  shippingProfileID
}: {
  cartTotal: number;
  paymentMethod: ApiPaymentGateWay;
  shippingProfileID: number | null;
}): Promise<
  | {
      rStatus: "success";
      rData: string;
    }
  | { rStatus: "error"; message: "mismatchError" | (string & {}) }
> {
  // TODO: work on status codes with BE
  try {
    const response = await apiFetcher({
      route: "/payment/link",
      method: "POST",
      options: {
        body: {
          feCartTotal: cartTotal,
          payGateID: paymentMethod.id,
          shippingProfileID: shippingProfileID
        }
      }
    });

    console.log(response);

    if (response.status === 200) {
      if (response.data && typeof response.data === "object") {
        if (
          "redirectUrl" in response.data &&
          typeof response.data.redirectUrl === "string"
        ) {
          return {
            rStatus: "success",
            rData: response.data.redirectUrl
          };
        }
      }
      return {
        rStatus: "error",
        message: i18n.t("Incorrect data received")
      };
    }

    console.log(response);

    if (response.status === 202) {
      return {
        rStatus: "error",
        message: i18n.t("No data received")
      };
    }

    if (response.status === 300) {
      return {
        rStatus: "error",
        message: "mismatchError"
      };
    }

    if (response.status === 209) {
      return {
        rStatus: "error",
        message: i18n.t("Purchase request already completed")
      };
    }

    if (response.status === 208) {
      return {
        rStatus: "error",
        message: i18n.t("Amount too low to process")
      };
    }

    return {
      rStatus: "error",
      message: i18n.t("An error occurred")
    };
  } catch (error) {
    return {
      rStatus: "error",
      message: i18n.t("An error occurred")
    };
  }
}

// /reward/daily

export async function fetchUserDailyCheckIn(): Promise<
  | {
      rStatus: "success";
      rData: { checkedIn: boolean };
    }
  | { rStatus: "error"; message: string }
> {
  try {
    const response = await apiFetcher({
      route: "/reward/daily",
      method: "POST",
      options: {
        body: {}
      }
    });

    if (response.status === 200) {
      console.log("DATA: ", response.data);
      if (!response.data || typeof response.data !== "object") {
        console.log("Response data is not an object");
        return {
          rStatus: "error",
          message: "Data is not an object"
        };
      }

      if (
        !("earned" in response.data) ||
        typeof response.data.earned !== "boolean"
      ) {
        return {
          rStatus: "error",
          message: "Data is not of type boolean"
        };
      }

      return {
        rStatus: "success",
        rData: { checkedIn: response.data.earned }
      };
    }

    return {
      rStatus: "error",
      message:
        "Couldn't fetch user daily check-in status. Please try again later."
    };
  } catch (error) {
    console.log(error);
    return {
      rStatus: "error",
      message: "An error occurred"
    };
  }
}
